<div class="not-found">
    <div class="not-found-container">
        <h1 i18n>OOPS!</h1>
        <div class="sub-text-1" i18n>You have made the Bison confused<br> and it caused <span>404 Error :/</span></div>
        <p i18n class="sub-text-2">You can still use the Bison Casino as intended by clicking the button below</p>
        <div class="button-wrapper">
            <button round-button filled="filled" color="accent" [routerLink]="['/']" i18n>Back to the game!</button>
        </div>
    </div>